import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.scss';
import About from './components/About';
import AppHeader from './components/AppHeader';
import Contact from './components/Contact';
import Engagements from './components/Engagements';
import NotFound from './components/NotFound';


const App = () => {


  return (

    <div className="container">
      <BrowserRouter>
        <AppHeader />
        <Routes>
          <Route path="/" element={<About/>} errorElement={<NotFound />} />
          <Route path="/about" element={<About/>} errorElement={<NotFound />} />
          <Route path="/engagements" element={<Engagements/>} errorElement={<NotFound />} />
          <Route path="/contact" element={<Contact/>} errorElement={<NotFound />} />
          <Route element={<NotFound />} />
          <Route path="*" element={<NotFound />} errorElement={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;

